import React, { useCallback, useState, useEffect } from 'react';
import _ from 'lodash';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import PropTypes from 'prop-types';
import { Coverage } from 'ml-components-common-react';
import appConfig from 'app-config';
import metadata from './IncludedFeaturesComponent.metadata.json5';
import qnbMetadata from './IncludedFeaturesComponent.qnb.metadata.json5';
import styles from './IncludedFeaturesComponent.module.scss';
import qnbStyles from './IncludedFeaturesComponent.qnb.module.scss';
import './IncludedFeaturesComponent.messages';

function IncludedFeaturesComponent(props) {
    const {
        model: coverages,
        showTooltip,
        hideTooltipHeader,
        useCoverageWrapperObj,
        isHomeowners
    } = props;
    const [showIncludedFeatures, updateShowIncludedFeatures] = useState(false);
    const isQnB = appConfig.portalCode === 'QB';

    const getAdditionalCoverages = useCallback(() => {
        let additionalCoveragesML = _.get(coverages, 'additionalCoverages_ML.value', []);
        if (_.isEmpty(additionalCoveragesML)) {
            additionalCoveragesML = _.get(coverages, 'value.includedFeatures_Ext', []);
        }
        if (_.isEmpty(additionalCoveragesML)) {
            additionalCoveragesML = _.get(coverages, 'additionalCoverages.value', []);
        }
        if (useCoverageWrapperObj) {
            return additionalCoveragesML.map(_.partial(Coverage.create, _, false, null))
        }
        return additionalCoveragesML;
    }, [coverages, useCoverageWrapperObj]);

    const additionalCoverages = getAdditionalCoverages();

    useEffect(() => {
        const hasSelectedFeature = additionalCoverages.some((feature) => feature.selected === true);
        updateShowIncludedFeatures(hasSelectedFeature);
    }, [additionalCoverages]);

    const generateOverrides = () => {
        const overrides = additionalCoverages.map((feature, index) => {
            return {
                [`selectedFeatureContainer${index}`]: {
                    visible: feature.selected
                },
                [`selectedFeature${index}`]: {
                    visible: !showTooltip
                },
                [`selectedfeatureTooltip${index}`]: {
                    visible: showTooltip,
                    tooltipContent: feature.description,
                    tooltipLabel: feature.name,
                    noHeader: isQnB ? true : hideTooltipHeader,
                    noWrapper: isQnB
                },
            };
        });

        return Object.assign({}, ...overrides);
    };

    const overrideProps = {
        includedFeaturesContainer: {
            visible: showIncludedFeatures
        },
        includedFeatures: {
            visible: !isHomeowners
        },
        features: {
            data: additionalCoverages
        },
        ...generateOverrides()
    };

    const resolvers = {
        resolveClassNameMap: isQnB ? qnbStyles : styles
    };

    return (
        <ViewModelForm
            uiProps={isQnB ? qnbMetadata.componentContent : metadata.componentContent}
            overrideProps={overrideProps}
            model={coverages}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

IncludedFeaturesComponent.propTypes = {
    model: PropTypes.shape({}).isRequired,
    showTooltip: PropTypes.bool,
    hideTooltipHeader: PropTypes.bool,
    useCoverageWrapperObj: PropTypes.bool,
    isHomeowners: PropTypes.bool
};

IncludedFeaturesComponent.defaultProps = {
    showTooltip: false,
    hideTooltipHeader: false,
    useCoverageWrapperObj: false,
    isHomeowners: false
};

export default IncludedFeaturesComponent;
